/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationEmployeeUsageLineChartQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
  startDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  sessionOrderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ApplicationEmployeeUsageLineChartQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', applications: Array<{ __typename: 'ClientApplicationType', id: string, employees?: { __typename: 'ClientEmployeeTypeConnection', edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', groupBy?: { __typename: 'ClientEmployeeSessionAggregateGroupByFieldType', sessionsPerDate?: Array<{ __typename: 'SessionsPerDateType', date?: any | null, count?: number | null } | null> | null } | null } | null } | null } | null } | null> } | null } | null> } | null } | null };



export const ApplicationEmployeeUsageLineChartDocument = `
    query ApplicationEmployeeUsageLineChart($applicationId: UUID!, $clientId: UUID!, $startDate: DateTime, $endDate: DateTime, $sessionOrderBy: String) {
  clientApplication(id: $applicationId, clientId: $clientId) {
    id
    resourceGroupApplications {
      applications {
        id
        employees {
          edges {
            node {
              id
              sessions(
                updatedAt_Gte: $startDate
                updatedAt_Lt: $endDate
                orderBy: $sessionOrderBy
              ) {
                aggregate {
                  groupBy {
                    sessionsPerDate {
                      date
                      count
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useApplicationEmployeeUsageLineChartQuery = <
      TData = ApplicationEmployeeUsageLineChartQuery,
      TError = unknown
    >(
      variables: ApplicationEmployeeUsageLineChartQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationEmployeeUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationEmployeeUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationEmployeeUsageLineChartQuery, TError, TData>(
      {
    queryKey: ['ApplicationEmployeeUsageLineChart', variables],
    queryFn: fetcher<ApplicationEmployeeUsageLineChartQuery, ApplicationEmployeeUsageLineChartQueryVariables>(ApplicationEmployeeUsageLineChartDocument, variables),
    ...options
  }
    )};

useApplicationEmployeeUsageLineChartQuery.getKey = (variables: ApplicationEmployeeUsageLineChartQueryVariables) => ['ApplicationEmployeeUsageLineChart', variables];

export const useInfiniteApplicationEmployeeUsageLineChartQuery = <
      TData = InfiniteData<ApplicationEmployeeUsageLineChartQuery>,
      TError = unknown
    >(
      variables: ApplicationEmployeeUsageLineChartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationEmployeeUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationEmployeeUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationEmployeeUsageLineChartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationEmployeeUsageLineChart.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationEmployeeUsageLineChartQuery, ApplicationEmployeeUsageLineChartQueryVariables>(ApplicationEmployeeUsageLineChartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationEmployeeUsageLineChartQuery.getKey = (variables: ApplicationEmployeeUsageLineChartQueryVariables) => ['ApplicationEmployeeUsageLineChart.infinite', variables];


useApplicationEmployeeUsageLineChartQuery.fetcher = (variables: ApplicationEmployeeUsageLineChartQueryVariables) => fetcher<ApplicationEmployeeUsageLineChartQuery, ApplicationEmployeeUsageLineChartQueryVariables>(ApplicationEmployeeUsageLineChartDocument, variables);
